module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ((_vm.getBlockModifiers()) + " " + (_vm.data.caption ? 'm-caption' : ''))
  }, [(_vm.data.caption) ? _c('span', {
    staticClass: "animation-caption"
  }, [_vm._v(_vm._s(_vm.data.caption))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79a86cab","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/blocks/Animation.vue
// module id = 393
// module chunks = 0